// Color names courtesy from https://www.colorhexa.com/
export const Colors = {
  DARKBLUE: '#003087',
  GREY: '#687173',
  LIGHTGRAYISHBLUE: '#EEEFF0',
  VERYLIGHTGREY: '#DCDCDC',
  LIGHTGREY: '#EBECEF',
  DARKGREY: '#666F7E',
  MOSTLYPUREBLUE: '#0070E0',
  PUREBLUE: '#0074DE',
  VERYDARKBLUE: '#001C64',
  VERYDARKBLUE2: '#001435',
  VERYDARKGRAYISHBLUE: '#545D68',
  LIGHTGRAYISHORANGE: '#E6E0D9',
  MEDIUMLIGHTGRAYISHORANGE: '#FAF8F5',
  VERYLIGHTGRAYISHORANGE: '#F1EDE8',
  DARKGRAYISHBLUE: '#929496',
  VERYDARKDESATURATEDBLUE: '#1C2940',
  WHITE: '#FFFFFF',
  BLACK: '#000F28'
};

// dark and light themes based on figma
export const PreviewThemeColors = {
  light: {
    backgroundMainColor: Colors.WHITE,
    backgroundAlternateColor: Colors.LIGHTGRAYISHORANGE,
    componentsColor: Colors.DARKGRAYISHBLUE,
    buttonLabel: Colors.WHITE,
    strokeColor: Colors.BLACK
  },
  dark: {
    backgroundMainColor: Colors.BLACK,
    backgroundAlternateColor: Colors.VERYDARKDESATURATEDBLUE,
    componentsColor: Colors.DARKGREY,
    buttonLabel: Colors.WHITE,
    strokeColor: Colors.WHITE
  }
};

export const MobileThemeColors = {
  light: {
    backgroundMainColor: Colors.WHITE,
    backgroundAlternateColor: Colors.WHITE,
    componentsColor: Colors.DARKGRAYISHBLUE,
    buttonLabel: Colors.WHITE,
    strokeColor: Colors.BLACK
  },
  dark: {
    backgroundMainColor: Colors.BLACK,
    backgroundAlternateColor: Colors.VERYDARKDESATURATEDBLUE,
    componentsColor: Colors.DARKGREY,
    buttonLabel: Colors.WHITE,
    strokeColor: Colors.WHITE
  }
};
